import Recaptcha from "./reacaptcha.component";

export default Recaptcha;